import React, { useState } from 'react';
import { portfolioData } from '../mock';
import { X } from 'lucide-react';

const DesignWork = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedImage, setSelectedImage] = useState(null);

  const filteredDesigns = selectedCategory === 'All' 
    ? portfolioData.designWork 
    : portfolioData.designWork.filter(d => d.category === selectedCategory);

  return (
    <section id="designs" className="py-32 bg-black border-t border-zinc-900">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="mb-20">
          <span className="text-sm tracking-[0.3em] text-zinc-500 uppercase font-medium mb-4 block">
            Graphic Design
          </span>
          <h2 className="text-6xl md:text-7xl font-black text-white tracking-tight">
            Designs
          </h2>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap gap-3 mb-16">
          {portfolioData.designCategories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2 text-sm font-medium transition-all duration-300 ${
                selectedCategory === category
                  ? 'bg-white text-black'
                  : 'bg-zinc-900 text-zinc-400 hover:bg-zinc-800 hover:text-white border border-zinc-800'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Masonry Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredDesigns.map((design, index) => (
            <div
              key={design.id}
              className="group cursor-pointer overflow-hidden bg-zinc-900"
              style={{
                animation: `fade-in-up 0.6s ease-out ${index * 0.08}s both`
              }}
              onClick={() => setSelectedImage(design)}
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={design.image}
                  alt={design.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/60 transition-all duration-300 flex flex-col items-center justify-center opacity-0 group-hover:opacity-100">
                  <span className="text-xs tracking-[0.2em] text-cyan-400 uppercase mb-2">
                    {design.category}
                  </span>
                  <h3 className="text-xl font-bold text-white text-center px-4">
                    {design.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-6 animate-fade-in"
          onClick={() => setSelectedImage(null)}
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-6 right-6 text-white hover:text-cyan-400 transition-colors p-2"
          >
            <X className="h-8 w-8" />
          </button>
          <div 
            className="relative max-w-6xl max-h-[90vh] animate-scale-in"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage.image}
              alt={selectedImage.title}
              className="max-w-full max-h-[80vh] object-contain"
            />
            <div className="mt-4 text-center">
              <span className="text-xs tracking-[0.2em] text-cyan-400 uppercase">
                {selectedImage.category}
              </span>
              <h3 className="text-2xl font-bold text-white mt-2">
                {selectedImage.title}
              </h3>
              <p className="text-zinc-400 mt-2">{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default DesignWork;
